import FavoritesContext from "../../store/favorites-context";
import { Link } from "react-router-dom";
import classes from "./MainNavigation.module.css";
import { useContext } from "react";
import { getAuth, signOut } from "firebase/auth";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { AuthContext } from "../../store/auth-context";
import { useNavigate } from "react-router-dom";

function MainNavigation() {
	const updateFaves = useContext(FavoritesContext);
	//check if user is logged in
	const { user } = useContext(AuthContext);
	const navigate = useNavigate();

	const handleLogin = () => {
		navigate("/login");
	}

	const handleLogout = (e) => {
		e.preventDefault();
		const auth = getAuth();
		signOut(auth);
	};

	return (
		<Navbar expand="lg" className={classes.main}>
			<Container>
				<Navbar.Brand className={classes.brand}>
					Wanderlust
				</Navbar.Brand>
				<Navbar.Toggle
					aria-controls="menubar"
					className={classes.toggle}
				/>
				<Navbar.Collapse id="menubar" className="justify-content-end">
					<Nav>
						<Nav.Link
							as={Link}
							to="/all-meetups"
							className={classes.links}
						>
							All Earthscapes
						</Nav.Link>
						<Nav.Link
							as={Link}
							to="/favorites"
							className={classes.links}
						>
							My Favorites
							<span className={classes.badge}>
								{updateFaves.totalFavorites}
							</span>
						</Nav.Link>
						<Nav.Link
							as={Link}
							to="/new-meetup"
							className={classes.links}
						>
							Add New Earthscape
						</Nav.Link>
						<Nav.Link
							as={Link}
							to="/about"
							className={classes.links}
						>
							About
						</Nav.Link>
						{user && (
							<button
								onClick={handleLogout}
								className={classes.button}
							>
								LogOut
							</button>
						)}
						{!user && (
							<button
								onClick={handleLogin}
								className={classes.button}
							>
								Login
							</button>
						)}
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default MainNavigation;
